import React from 'react';
import Text from 'ui/Text';

const PageNotFound = () => {
    return (
        <div className="text-center">
            <Text type="heading">404?</Text>
            <Text type="explanation">This page doesn't exist</Text>
        </div>
    );
};

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/shared/PageNotFound.js